import React from 'react';
import { useSelector } from 'react-redux';

import AdminContent from 'src/presentation/components/pages/home/AdminContent';
import NonAdminContent from 'src/presentation/components/pages/home/NonAdminContent';
import agentProfileResource from 'src/actions/agent/agentProfileResource';
import { H1 } from '@ad-scripts/presentation/components/common/headers';
import {
  TableLayoutHeightRestrictor,
  Flexer,
  PageContainer,
  HeaderContainer,
} from 'src/presentation/components/pages/shared/FormPage';
import { useResourceValue } from 'src/presentation/hooks/useDocumentResource';
import { RootState } from 'src/actions/configuration/rootReducer';

const adminRoles = ['compliance-admin', 'system-admin'];

const Home = () => {
  const { value: agentProfile } = useResourceValue(agentProfileResource);
  const dataAidPrefix = 'admin-home-page';
  const roleIds = useSelector((state: RootState) => state.auth.roleIds) as string[];
  const isAdminView = roleIds?.some(role => adminRoles.includes(role));
  const title = agentProfile.name ? `Hi, ${agentProfile.name}!` : 'Welcome!';
  return (
    <TableLayoutHeightRestrictor>
      <Flexer>
        <PageContainer data-aid={dataAidPrefix}>
          <HeaderContainer>
            <H1 data-aid="page-header">{title}</H1>
            {isAdminView ? <AdminContent /> : <NonAdminContent />}
          </HeaderContainer>
        </PageContainer>
      </Flexer>
    </TableLayoutHeightRestrictor>
  );
};

export default Home;
